import { render, staticRenderFns } from "./appAboutPage.vue?vue&type=template&id=11283354&scoped=true"
import script from "./appAboutPage.vue?vue&type=script&lang=js"
export * from "./appAboutPage.vue?vue&type=script&lang=js"
import style0 from "./appAboutPage.vue?vue&type=style&index=0&id=11283354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11283354",
  null
  
)

export default component.exports